module.exports = __webpack_public_path__ + "img/icon_5_97.8b6daaa9.png";